const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

function stripTrailingSlash(value) {
  return value.replace(/\/+$/, '');
}

export function getBackendBaseUrl() {
  const configured = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (configured) {
    return stripTrailingSlash(configured);
  }

  if (typeof window !== 'undefined' && LOCAL_HOSTNAMES.has(window.location.hostname)) {
    return 'http://localhost:8000';
  }

  return '';
}

export function hasConfiguredBackendUrl() {
  return Boolean((process.env.REACT_APP_BACKEND_URL || '').trim());
}

export function isLocalBrowserHost() {
  if (typeof window === 'undefined') {
    return false;
  }
  return LOCAL_HOSTNAMES.has(window.location.hostname);
}

export function getBackendLabel() {
  return getBackendBaseUrl() || 'same-origin';
}
